export interface RegulationFeedItem {
  title: string;
  category: string;
  link: string;
  description: string;
  pubDate: string;
  guid: string;
}

export interface RegulationFeedList extends Array<RegulationFeedItem> {}

export function getRegulationFeedItemFromXML(
  string: string,
): RegulationFeedItem {
  const parser = new DOMParser();
  const xmlDocument = parser.parseFromString(string, 'text/xml');

  const itemDocument = xmlDocument.querySelector('item');

  if (itemDocument === null) {
    throw new Error('No item');
  }

  const item = Object.fromEntries(
    Array.from(itemDocument.childNodes).map((element: ChildNode) => {
      if (element.textContent === null) {
        throw new Error(
          "Missing textContent from key '" + element.nodeName + "'",
        );
      }

      return [element.nodeName, element.textContent];
    }),
  );

  return {
    title: item.title,
    category: item.category,
    link: item.link,
    description: item.description,
    pubDate: item.pubDate,
    guid: item.guid,
  };
}

export function getRegulationFeedFromXML(feed?: string): RegulationFeedList {
  if (feed === undefined || feed.length === 0) {
    return [];
  }

  const matches = feed.matchAll(/<item>.+?<\/item>/g);
  const unformattedItems = Array.from(matches).flat();

  const items = unformattedItems.map((string) =>
    getRegulationFeedItemFromXML(string),
  );
  return items;
}
